import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import VendorDeptStaticCell from './VendorDeptStaticCell';

const VendorDeptStateRows = ({ headerRows, data }) => {
  if (!headerRows || !data) {
    return null;
  }

  return (
    data &&
    data.map((vendor, vIndex) => {
      return vendor.children.map((partner, pIndex) => {
        let id = vendor.id + partner.id;
        return (
          <TableRow key={id}>
            {pIndex === 0 && (
              <TableCell
                sx={{ width: '180px' }}
                align="center"
                rowSpan={
                  vendor.children.length > 1 ? vendor.children.length : 1
                }
              >
                {vendor.name}
              </TableCell>
            )}
            <TableCell sx={{ width: '200px' }} align="center" rowSpan={1}>
              {partner.name}
            </TableCell>
            <VendorDeptStaticCell headerRows={headerRows} data={partner} />
          </TableRow>
        );
      });
    })
  );
};

export default VendorDeptStateRows;
